export const SharedIcon = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.56 5.435C4.515 5.43 4.46 5.43 4.41 5.435C3.305 5.395 2.425 4.49 2.425 3.375C2.425 2.235 3.345 1.315 4.49 1.315C5.63 1.315 6.555 2.24 6.555 3.375C6.55 4.49 5.67 5.395 4.56 5.435Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.14 2C9.06 2 9.8 2.745 9.8 3.66C9.8 4.555 9.09 5.285 8.21 5.32C8.175 5.315 8.135 5.315 8.095 5.32"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.07502 7.285C0.950024 8.04 0.950024 9.26 2.07502 10.01C3.35502 10.865 5.47002 10.865 6.75002 10.01C7.87502 9.255 7.87502 8.035 6.75002 7.285C5.47502 6.435 3.36002 6.435 2.07502 7.285Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.165 9.75C9.505 9.675 9.825 9.53 10.085 9.315C10.81 8.745 10.81 7.81 10.085 7.24C9.83 7.03 9.515 6.89 9.18 6.81"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
